// extracted by mini-css-extract-plugin
export default {"footer_container":"footer_footer_container__pkjg1","section_one":"footer_section_one__VMeWb","section_two":"footer_section_two__Lql0n"};